(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ev-vehicle-fit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ev-vehicle-fit')) {
    customElements.define('ev-vehicle-fit', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.rows = Array.from(this.querySelectorAll('[data-fit-approval]')).map(el => ({...el.dataset}));
        this.model = this.querySelector('[data-fit-model]');
        if (!this.model) return;
        this.motor = this.querySelector('[data-fit-motor]');
        this.year = this.querySelector('[data-fit-year]');
        this.result = this.querySelector('[data-fit-result]');
        this.modelKey = row => JSON.stringify([row.manufacturer, row.model, row.vehicleType]);
        this.options(this.model, this.dataset.modelLabel, this.rows.filter(r => r.manufacturer && r.model && r.vehicleType).map(r => [this.modelKey(r), `${r.manufacturer} ${r.model} (${r.vehicleType})`]));
        this.options(this.motor, this.dataset.motorLabel, []);
        this.querySelector('[data-fit-controls]').hidden = false;
        this.model.addEventListener('change', () => {
          this.options(this.motor, this.dataset.motorLabel, this.rows.filter(r => this.modelKey(r) === this.model.value && r.motor).map(r => [r.motor, r.motor]));
          this.motor.disabled = !this.model.value || this.model.value === '__other';
          this.year.value = '';
          this.updateYearLabel();
          this.result.hidden = true;
        });
        this.motor.addEventListener('change', () => { this.updateYearLabel(); this.result.hidden = true; });
        this.year.addEventListener('input', () => { this.result.hidden = true; });
        this.querySelector('[data-fit-check]').addEventListener('click', () => this.check());
      }
      options(select, placeholder, pairs) {
        select.replaceChildren(new Option(placeholder, ''));
        const seen = new Set();
        pairs.forEach(([value, label]) => {
          if (!seen.has(value)) { select.add(new Option(label, value)); seen.add(value); }
        });
        select.add(new Option(this.dataset.otherLabel, '__other'));
      }
      matchingRows() {
        return this.rows.filter(r => this.modelKey(r) === this.model.value && r.motor === this.motor.value);
      }
      updateYearLabel() {
        const bases = [...new Set(this.matchingRows().map(r => r.basis).filter(Boolean))];
        this.querySelector('[data-fit-year-label]').textContent = bases.length === 1 ? bases[0] : this.dataset.yearLabel;
      }
      check() {
        const yearText = this.year.value.trim();
        const year = Number(yearText);
        const other = this.model.value === '__other' || this.motor.value === '__other';
        const complete = this.model.value && this.motor.value && /^\d{4}$/.test(yearText);
        const matches = complete && !other ? this.matchingRows().filter(r => {
          const from = r.from ? Number(r.from) : null;
          const to = r.to ? Number(r.to) : null;
          return r.approved === 'true' && r.yearsVerified === 'true' && r.basis && r.tire &&
            (from === null || (Number.isInteger(from) && year >= from)) &&
            (to === null || (Number.isInteger(to) && year <= to));
        }) : [];
        const confirmed = matches.length > 0;
        this.result.hidden = false;
        this.result.classList.toggle('kr__fit-result--confirmed', confirmed);
        this.result.classList.toggle('kr__fit-result--unknown', !confirmed);
        this.result.textContent = confirmed ? this.dataset.confirmed + ' ' + [...new Set(matches.map(r => r.tire))].join(', ') : other || complete ? this.dataset.unknown : this.dataset.choose;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
